import script from "./HolidayCalendar.vue?vue&type=script&setup=true&lang=js"
export * from "./HolidayCalendar.vue?vue&type=script&setup=true&lang=js"

import "./HolidayCalendar.vue?vue&type=style&index=0&id=08b98c60&lang=scss&scoped=true"
import "./HolidayCalendar.vue?vue&type=style&index=1&id=08b98c60&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-08b98c60"]])

export default __exports__